"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn.Lazyan
 * @since 9/14/2017
 */
var core_1 = require("@angular/core");
require("rxjs/add/observable/of");
require("rxjs/add/operator/mergeMap");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var sso_config_1 = require("../../sso-pre-login/sso-config");
var login_service_1 = require("../../../services/login.service");
var TokenExpirationService = /** @class */ (function () {
    function TokenExpirationService(tokenInfoService, authenticationService, applicationPropertiesService, loginService) {
        var _this = this;
        this.tokenInfoService = tokenInfoService;
        this.authenticationService = authenticationService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.loginService = loginService;
        this._openSubscriptions = [];
        this._openSubscriptions.push(this.authenticationService
            .getUserData()
            .subscribe(function (userData) {
            _this._userData = userData;
        }));
    }
    TokenExpirationService.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    TokenExpirationService.prototype.loginByPassword = function (password) {
        return this.loginService.loginOrGetErrorMessage(this._userData.username, password, {
            doNotRedirectOnSuccess: true
        });
    };
    TokenExpirationService.prototype.isTokenValid = function () {
        return this.tokenInfoService.tokenValidityObservable;
    };
    TokenExpirationService.prototype.tokenUpdatedViaQuickLogin = function (updated) {
        this.tokenInfoService.tokenUpdatedViaQuickLogin.next(updated);
    };
    TokenExpirationService.prototype.loginViaSAML = function () {
        var _this = this;
        return this.applicationPropertiesService
            .getProperty(sso_config_1.SSOConfig.SSO_SERVICE_URL_KEY)
            .then(function (serviceUrl) {
            var url = serviceUrl + sso_config_1.SSOConfig.SSO_LOGIN_URL
                + '?' + sso_config_1.SSOConfig.SSO_HOME_URL_QUERY_PARAM + _this.loginService.getSAMLRedirectUrl()
                + '&' + sso_config_1.SSOConfig.SSO_DEEP_URL_QUERY_PARAM + sso_config_1.SSOConfig.SSO_PRE_LOGIN_URL;
            return window.open(url, 'myWindow', 'width=500,height=500,top=100,left=380');
        })
            .catch(function (error) { return console.error(error); });
    };
    TokenExpirationService.prototype.logout = function () {
        this.loginService.logout();
    };
    TokenExpirationService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.TokenInfoService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            login_service_1.LoginService])
    ], TokenExpirationService);
    return TokenExpirationService;
}());
exports.TokenExpirationService = TokenExpirationService;
//# sourceMappingURL=token-expiration.service.js.map